  import { useRef, useState } from "react"
  import TabsCustom from "src/components/TabsCustom"
  import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
  import Button from "src/components/MyButton/Button"
  import { StyleTabsCustom } from "src/components/TabsCustom/styled"
  import { ToolBarStyle } from "../../HumanResource/Work/Task/styled"
  import WarehouseEntry from "./SimWarehouse/components/WarehouseEntry"
  import SvgIcon from "src/components/SvgIcon"
  import { Input, Select, DatePicker } from "antd"
  import ModalCreate from "./SimWarehouse/Modal/ModalCreate"
  import { InputSearchStyle } from "../Setting/common/styled"
  import FilterIn from "./SimWarehouse/components/FilterIn"
  import STORAGE from "src/lib/storage"
import FilterSim from "./components/FilterSim"
  
  const SimWareHouse = props => {
    const [disableBtn, setDisableBtn] = useState(false)
    const [tab, setTab] = useState("1")
    const [searchTerm, setSearchTerm] = useState("")
    const [openModalCreate, setOpenModalCreate] = useState(false)
    const [activeKey, setActiveKey] = useState("pending")
    
    const Tabs = {
      all: {
        type: "all",
        name: "Tất cả",
        status: 2,
      },
      pending: {
        type: "pending",
        name: "Chờ duyệt",
        status_order: "505",
      },
      reject: {
        type: "reject",
        name: "Từ chối",
        status_order: "515",
      },
      success: {
        type: "success",
        name: "Đã duyệt",
        status_order: "501",
      },
    }
  
    const items = Object.keys(Tabs).map(key => ({
      key,
      label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
      children: [
     
        <WarehouseEntry type={Tabs[key].type} scroll={{ x: true }} />,
      ],
    }))
  
    return (
      <div>
        <WrapperStyle>
          <ToolBarStyle>
            {/* <div className="left-side">
            <div>QUẢN LÝ KHO SIM</div>
            </div> */}
            <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 4,
                    marginBottom: 20,
                    flexWrap: "wrap",
                    gap: 8,
                  }}
                >
                  <h3
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: "#005F90",
                      margin: 0,
                    }}
                  >
                  QUẢN LÝ KHO SIM
                  </h3>
                </div>
            <div className="right-side">
              {/* <Button
                btnType="primary1"
                onClick={() => setOpenModalCreate(true)}
                size="small"
                disabled={disableBtn}
              >
                Tạo yêu cầuuuuu
              </Button> */}
            </div>
            <StyleTabsCustom>
              <TabsCustom
                onChange={activeKey => setActiveKey(activeKey)}
                activeKey={activeKey}
                items={items}
                defaultActiveKey="all"
                type="card"
                destroyInactiveTabPane={true}
                scroll={{ x: true }}
              />
            </StyleTabsCustom>
          </ToolBarStyle>
        </WrapperStyle>
        {openModalCreate && (
          <ModalCreate
            open={openModalCreate}
            onCancel={() => setOpenModalCreate(false)}
            onOk={() => {
              setOpenModalCreate(false)
            }}
          />
        )}
      </div>
    )
  }
  
  export default SimWareHouse
